import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { TOKEN_KEY } from "../../utils/request";
import { ADMIN_ROLE, getAdminDefaultPathForRoles, userHasAnyRole } from "../../utils/user";

interface AdminGuardProps {
  children: React.ReactNode;
  allowedRoles?: readonly string[];
}

export default function AdminGuard({ children, allowedRoles = [ADMIN_ROLE] }: AdminGuardProps) {
  const token = localStorage.getItem(TOKEN_KEY);
  const { user, loading } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (loading && !user) return null;

  if (!userHasAnyRole(user?.roles, allowedRoles)) {
    return <Navigate to={getAdminDefaultPathForRoles(user?.roles)} replace />;
  }

  return <>{children}</>;
}
